import React from 'react';
import HorizontalPillTabs from './HorizontalPillTabs';
import {
  ALL_VARIETY_GROUP_ID,
  getVarietyGroupTabs,
  resolveActiveVarietyGroupId,
} from '../utils/varietyGroups';

const VarietyGroupTabs = ({
  groups = [],
  activeGroupId = ALL_VARIETY_GROUP_ID,
  onSelect,
  className = '',
}) => {
  const tabs = getVarietyGroupTabs(groups);
  if (!tabs.length) return null;
  const resolvedActiveId = resolveActiveVarietyGroupId(activeGroupId, groups);

  return (
    <HorizontalPillTabs
      items={tabs}
      activeId={resolvedActiveId}
      onSelect={(id) => onSelect?.(String(id || ALL_VARIETY_GROUP_ID))}
      className={className}
    />
  );
};

export default VarietyGroupTabs;
